import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectDealerMyCarPark, selectJob, selectJobTasks, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { KeepActions } from 'src/app/common/store/actions/keep.actions';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { Car } from 'src/app/public/car/models/car.model';
import { CommonBasicData, ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { KeepBasicData, JobAction } from '../../constants/keep-basic-data';
import { JobItem } from '../../models/job-item.model';
import { Job } from '../../models/job.model';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-job-item-dialog',
    templateUrl: './job-item-dialog.component.html',
    styleUrls: ['./job-item-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSelectModule, AsyncPipe]
})
export class JobItemDialogComponent implements OnInit{

  job$ : Observable<Job | undefined>;
  job: Job = new Job();

  jobItem: JobItem = new JobItem();
  jobItemIndex = 0

  currentUserId$ : Observable<string>;
  currentUserId: string = "";

  myCars$ : Observable<Car[]>;
  myCars: Car[] = [];

  jobTasks$ : Observable<CarJobTask[]>;
  jobTasks: CarJobTask[] = [];

  disabled = false;

  serviceTypesBD = CommonBasicData.serviceTypes;
  jobTypesBD = KeepBasicData.jobTypes;
  jobCategoriesBD = KeepBasicData.carJobCategories;
  locationModesBD = CommonBasicData.locationModes;
  
  isNew: boolean = false;

  ServiceType= ServiceType 

  constructor(
    public dialogRef: MatDialogRef<JobItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.job$ = store.select(selectJob( data.objectSource, data.offerId, ""+data.objectId, data.carId ));
      
      this.jobTasks$ = this.store.select(selectJobTasks); 
      this.myCars$ = store.select(selectDealerMyCarPark);
    }

    ngOnInit(): void {

      this.store.dispatch (CarRefActions.jobTasksFetchSubmit({}));
      this.store.dispatch(DealerActions.fetchProviderParkSubmit()); 

      this.isNew = (this.data.itemId === 0);
      console.log(this.data.offerId)

      this.job.offerId = this.data.offerId
      this.job.carId = this.data.carId
      this.job.jobId = ""+this.data.objectId

      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );

      this.job$.subscribe(
        (jb: Job | undefined) => {
          
          if(jb === undefined){

            console.log("1 ghhhhhhhhhh ")
            this.job = new Job()
            this.job.offerId = this.data.offerId
            this.job.carId = this.data.carId
            this.job.jobId = ""+this.data.objectId

            this.jobItem = new JobItem()
          }
          else{
            console.log("2 ghhhhhhhhhh ")
            this.job = JSON.parse(JSON.stringify(jb))
            //this.jobItemIndex = this.job.jobItems.findIndex(item => item.jobItemId === this.data.itemId)
            this.jobItem = this.job.jobItems.find( (item: JobItem) => item.jobItemId === this.data.itemId)!
            if(this.jobItem == undefined){
              this.jobItem = new JobItem()
              this.jobItem.jobId = this.data.objectId
            }
          }
          
          console.log(this.job.offerId)

          //this.job.offerId = this.data.offerId
        }
      );
    } 
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  submitJob(){

    console.log(this.job)
        
    if(+this.job.jobId === 0){
      this.store.dispatch(KeepActions.jobNewSubmit ( { job: this.job, objectSource: this.data.objectSource }));
    }
    else{
      //this.store.dispatch(KeepActions.jobUpdateSubmit ( { job: this.job, objectSource: this.data.objectSource })); 
      this.store.dispatch(KeepActions.jobActionSubmit ( { jobAction: JobAction.EDIT, job: this.job, objectSource: this.data.objectSource }));
    }
    this.dialogRef.close();
  }

  submitJobItem(){

    console.log(this.jobItem)
        
    if(+this.jobItem.jobItemId > 0){
      this.store.dispatch(KeepActions.jobItemUpdateSubmit ( { jobItem: this.jobItem, objectSource: this.data.objectSource })); 
    }
    else{
      this.store.dispatch(KeepActions.jobItemNewSubmit ( { jobItem: this.jobItem, objectSource: this.data.objectSource }));
    }
    this.dialogRef.close();
  }

  onLocationModeChange(){

  }

  onEmergencyChange(){

  }
}
